<template>
    <div class="base-star-rating">
        <svg width="37" height="36" viewBox="0 0 13 12" v-for="item of 5" :key="item" fill="none"
            @click="onUpdateNum(item)" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.16306 0.816223C5.52987 0.0729771 6.58971 0.0729783 6.95653 0.816224L8.03132 2.99398C8.17698 3.28913 8.45854 3.4937 8.78425 3.54102L11.1876 3.89024C12.0078 4.00943 12.3353 5.0174 11.7418 5.59594L10.0027 7.29108C9.76704 7.52082 9.65949 7.85182 9.71513 8.17622L10.1257 10.5698C10.2658 11.3867 9.40834 12.0097 8.67471 11.624L6.52513 10.4939C6.23381 10.3407 5.88578 10.3407 5.59445 10.4939L3.44488 11.624C2.71125 12.0097 1.85381 11.3867 1.99393 10.5698L2.40446 8.17622C2.4601 7.85182 2.35255 7.52082 2.11686 7.29109L0.377819 5.59594C-0.215698 5.0174 0.111811 4.00943 0.932031 3.89024L3.33533 3.54102C3.66104 3.4937 3.94261 3.28913 4.08827 2.99398L5.16306 0.816223Z"
                :fill="item <= currentNum ? '#F5B704' : '#CACACA'" />
        </svg>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Number,
        },
    },
    data() {
        return {
            currentNum: this.value
        }
    },
    methods: {
        onUpdateNum(data) {
            this.currentNum = data
            this.$emit('updateNum', this.currentNum)
        }
    }
}
</script>


<style lang="scss">
.base-star-rating {
    display: flex;
    gap: 15px;
    svg {
        cursor: pointer;
    }
}
</style>